import { useState } from 'react';
import { toValue } from './utils.js';
/**
 * useListBoxState
 * - State hook for managing listbox accessibility, keyboarding, and option selection
 * @returns
 */
export const useListBoxState = (defaultSelected) => {
    // Per ARIA 1.2, Use aria-active-descendant to visually indicate focus on the active element
    // while keeping keyboard/DOM focus on the input
    const [activeDescendant, setActiveDescendant] = useState();
    const [selected, setSelected] = useState(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : '');
    const multiple = Array.isArray(selected);
    const handleOptionSelect = (option) => {
        // If selected is an array, add/remove option
        // Otherwise, just set the value
        setSelected((prevSelected) => {
            const value = toValue(option);
            // Multiple case
            if (Array.isArray(prevSelected)) {
                return prevSelected.find((opt) => toValue(opt) === value)
                    ? prevSelected.filter((opt) => toValue(opt) !== value)
                    : [...prevSelected, option];
            }
            else {
                setActiveDescendant('');
                // Single case (ternary allows users to remove a selection if desired)
                return option === prevSelected ? '' : option;
            }
        });
    };
    const onClear = () => {
        setSelected(multiple ? [] : '');
    };
    return {
        activeDescendant,
        multiple,
        onActiveDescendantChange: setActiveDescendant,
        onClear,
        onOptionSelect: handleOptionSelect,
        selected,
    };
};
